import React from 'react';
import './style.css';

const HowItWorks = () => {
  const steps = [
    {
      title: "Initial Contact",
      description: "Starts with 10 min introductory call with Krinjal Team and Sponsor",
      icon: "📞"
    },
    {
      title: "Sponsor Approval",
      description: "Once sponsor gives ok",
      icon: "✅"
    },
    {
      title: "Regular Updates",
      description: "Every 4 month update is sent to sponsor regarding education, health, extra curricular activities etc.",
      icon: "📊"
    },
    {
      title: "Annual Review",
      description: "At the end of year, we will ask sponsor if they want to continue scholarship for another year.",
      icon: "📅"
    },
    {
      title: "Process Continuation",
      description: "Process restarts in new year",
      icon: "🔄"
    }
  ];

  return (
    <div className="wpo-contact-pg-section" style={{ paddingBottom: '50px' }}>
      <div className="container">
        <div className="row">
          <div className="col col-lg-10 offset-lg-1 col-12">
            <div className="office-info">
              <div className="row">
                <div className="col col-xl-12 col-lg-12 col-12">
                  {/* <div className="wpo-contact-title">
                    <h3>Looking to sponsor an education?</h3>
                  </div> */}
                  <div className="wpo-contact-form-area">
                    <div className="steps-container">
                      {steps.map((step, index) => (
                        <div key={index} className="step-card">
                          <div className="step-icon">{step.icon}</div>
                          <div className="step-content">
                            <h3>{step.title}</h3>
                            <p>{step.description}</p>
                          </div>
                          {index < steps.length - 1 && <div className="step-connector" />}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks; 